import {
  updateMultiFacet,
  dismissFloorFilter,
  updateSortFacet,
  clearSelections,
  restoreOldSelectedFacets
} from "../../store/actionCreators";
import {
  updateMultiFacetReducer,
  dismissFloorFilterReducer,
  updateSortFacetReducer,
  clearSelectionsReducer,
  restoreOldSelectedFacetsReducer
} from "../reducers";

export const registerFiltersSlice = (builder, dependencies) => {
  builder
    .addCase(updateMultiFacet, (state, action) =>
      updateMultiFacetReducer(state, action, dependencies)
    )
    .addCase(dismissFloorFilter, dismissFloorFilterReducer)
    .addCase(updateSortFacet, updateSortFacetReducer)
    .addCase(clearSelections, (state, action) =>
      clearSelectionsReducer(state, action, dependencies)
    )
    .addCase(restoreOldSelectedFacets, restoreOldSelectedFacetsReducer);
};
